<div class="container">
  <!-- <div cladd="d-flex w-100">
  
    </div> -->
  <!-- <div class="screen1 w-50">
      <img class="titleLogo" src="assets/images/SBlogo.png" alt="logo" />
    </div> -->
  <div class="screen w100">
    <div class="screen__content">
      <img class="titleLogo_onTop" src="assets/images/SourceBLogo.png" alt="logo" />
      <form [formGroup]="form" class="login">
        <div class="login__field">
          <!-- <i class="login__icon mdi mdi-account-outline"></i> -->
          <i class="login__icon fa fa-user"></i>
          <input type="text" class="login__input" placeholder="User Id" formControlName="username" required />
        </div>
        <!-- <div class="login__field">
          
          <i class="login__icon fa fa-lock"></i>
          <input type="password" id="password" class="login__input" placeholder="Password" formControlName="password"
            required />
          <div class="password-toggle" (click)="password_show_hide()">
            <i class="mdi mdi-eye-outline edit-icon" id="show_eye"></i>
            <i class="mdi mdi-eye-off-outline d-none edit-icon" id="hide_eye"></i>
          </div>
        </div> -->
        <div class="login__field">
          <i class="login__icon fa fa-lock"></i>

          <input type="password" id="password" class="login__input" placeholder="Password" formControlName="password"
            required />

         
          <i class="fa-solid fa-eye toggle-password" id="show_eye" (click)="password_show_hide()"></i>
          <i class="fa-solid fa-eye-slash toggle-password d-none" id="hide_eye" (click)="password_show_hide()"></i>
        </div>




        <div *ngIf="loginError" class="error-message">
          {{ loginError }}
        </div>

       
        <button class="button login__submit" (click)="signUp()">
          <span class="button__text">Sign In</span>
          <i class="button__icon mdi mdi-arrow-right"></i>
        </button>
      </form>
      <!-- <div>
        <button (click)="keycloakInit()">keycloakLogin</button>
        <button (click)="getToken()">getToken()</button>
        <button (click)="getUsername()">getUsername()</button>
        <button (click)="logout()">logout()</button>
      </div> -->
      <!-- Copyright -->
      <footer>
        <div class="text-center p-3 footer_div" style="background-color: rgba(0, 0, 0, 0.05);">
          <!-- © 2020 Copyright:
            <a class="text-body" href="https://mdbootstrap.com/">MDBootstrap.com</a> -->
          <!-- Copyright (c) 2025 Wyzmindz Pvt. Ltd. -->
          © 2025 Copyright Idamtat Technologies
        </div>
        <!-- Copyright -->
      </footer>
    </div>
    <div class="screen__background">
      <span class="screen__background__shape screen__background__shape4"></span>
      <span class="screen__background__shape screen__background__shape3"></span>
      <span class="screen__background__shape screen__background__shape2"></span>
      <span class="screen__background__shape screen__background__shape1"></span>
    </div>
  </div>
</div>